import useSWRFetcher, { SWRFetchError } from "../commonly-stored/fetcher";
import useSWR from "swr";
import settings from "../../../constants/settings";
import { ShipmentsPartResponse } from "./shipmentsThatNeedPart";
import { useEffect } from "react";
import { useCustomAlert } from "../alerts";

export default function useUpcomingShipmentsUsingPart(
  partIdOrContainerBarcode: string,
  onError?: () => void,
) {
  const fetcher = useSWRFetcher<ShipmentsPartResponse>();
  const customAlert = useCustomAlert();

  const { data, error } = useSWR<ShipmentsPartResponse, SWRFetchError>(
    `${settings.api_url}/parts/${partIdOrContainerBarcode}/upcoming-shipments`,
    fetcher,
  );

  useEffect(() => {
    if (error?.status === 404 && onError !== undefined) {
      customAlert("No container with this barcode exists");
      onError();
    }
  }, [customAlert, error?.status, onError]);

  useEffect(() => {
    if (error?.status === 400 && onError !== undefined) {
      customAlert("Invalid input");
      onError();
    }
  }, [customAlert, error?.status, onError]);

  return {
    shipmentsPartResponse: data || null,
  };
}
